import React from 'react';
import { getDomainById } from '../shared/constants/domains';

/**
 * Weakness alert cards — stale domains, accuracy drops, unseen content.
 */
export default function WeaknessAlerts({ alerts }) {
  if (alerts.length === 0) {
    return (
      <div className="bg-green-900/20 border border-green-700/30 rounded-xl p-4">
        <div className="flex items-center gap-2">
          <span className="text-lg">✅</span>
          <span className="text-green-300 text-sm">No weaknesses detected. Keep up the great work!</span>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <h3 className="text-sm font-medium text-gray-400 uppercase tracking-wider mb-2">Alerts</h3>
      {alerts.map((alert, i) => {
        const domain = getDomainById(alert.domainId);
        const isHigh = alert.severity === 'high';

        return (
          <div
            key={i}
            className={`border rounded-lg p-4 ${
              isHigh
                ? 'bg-red-900/20 border-red-700/30'
                : 'bg-amber-900/20 border-amber-700/30'
            }`}
          >
            <div className="flex items-start gap-3">
              <span className="text-lg">{isHigh ? '🔴' : '🟡'}</span>
              <div>
                <div className={`text-sm font-medium ${isHigh ? 'text-red-300' : 'text-amber-300'}`}>
                  {alert.message}
                </div>
                <div className="text-xs text-gray-400 mt-1">{alert.detail}</div>
                {domain && (
                  <div className="mt-2">
                    <span
                      className="inline-block text-xs px-2 py-0.5 rounded-full"
                      style={{ backgroundColor: `${domain.color}20`, color: domain.color }}
                    >
                      {domain.name}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
